import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const Content = styled.div`
  table,
  table td,
  table tr,
  table thead tr th {
    border: none !important;
  }

  table td {
    padding: 0.75rem 3.5rem 0.75rem 0 !important;
  }

  table tbody tr {
    border-bottom: none !important;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    table td {
      width: 50% !important;
    }
  }
`;

export const InterestTable = styled.table``;

export const InterestTbody = styled.tbody``;

export const InterestTr = styled.tr``;

export const InterestTd = styled.td``;

export const StyledP = styled.p`
  margin-top: 0 !important;
  margin-bottom: 1rem !important;
`;
